import { Heart } from "lucide-react";

export default function Footer() {
	return (
		<footer className="border-t mt-12">
			<div className="container mx-auto px-4 py-6">
				<div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
					<span>Made with</span>
					<Heart className="h-4 w-4 fill-red-500 text-red-500" />
					<span>by Kucho</span>
				</div>
			</div>
		</footer>
	);
}
